import { Footer, Navbar } from 'layout';
import { Wrapper } from './styles';
import { BasicLayoutProps } from './types';

export const Basic = ({ children }: BasicLayoutProps) => {
  return (
    <Wrapper>
      <Navbar />
      {children}
      <Footer />
    </Wrapper>
  );
};
